import type { ObjectMetadata } from '@olytic/foundation';

import { OBJECT_DEFS } from '../../objects/objectDefs';
import { asCheck, asDateTime, asLabel, field, lastModifiedByField, lookup, type Row, text } from './kit';

const def = OBJECT_DEFS['opportunity-contacts'];

/** A contact's role on an opportunity. Rationale: opportunity-contacts.md. */
export const opportunityContacts: ObjectMetadata<Row> = {
  key: def.key,
  singular: 'Contact role',
  plural: def.label,
  icon: def.icon,
  listColumns: def.columns,
  details: [
    field('contact_name', 'Contact', { link: lookup('contacts', 'contact_id') }),
    field('opportunity_name', 'Opportunity', { link: lookup('opportunities', 'opportunity_id') }),
    field('role', 'Role', { format: asLabel }),
    field('is_primary', 'Primary', { format: asCheck }),
    field('title', 'Title'),
    field('email', 'Email'),
    field('created_at', 'Added', { format: asDateTime }),
    field('created_by_name', 'Added by'),
    lastModifiedByField(),
  ],
  sections: [
    { key: 'identity', fields: ['contact_name', 'opportunity_name', 'role', 'is_primary', 'title', 'email'] },
    { key: 'system', label: 'System', collapsed: true, fields: ['created_at', 'created_by_name', 'last_modified_by_name'] },
  ],
  related: [],
  titleOf: (row) => text(row.name),
  searchKeys: ['name', 'contact_name', 'opportunity_name'],
};
